import React, { useContext } from "react";
import { AosContext } from "../Context/AosContext";
import { SectionFluid } from "./Section.elements";

const Section = ({ children, title, even }) => {
  const delay = useContext(AosContext);
  return (
    <SectionFluid even={even}>
      <div className="res-cnt">
        <div className="title-cnt">
          <h2 data-aos="fade-left">{title}</h2>
          <span data-aos="fade-left"></span>
        </div>
        {children}
      </div>
    </SectionFluid>
  );
};

export default Section;
